import type { IntlShape } from "@formatjs/intl";
import type { HookAPI } from "antd/es/modal/useModal";
import { type State as RouterState } from "router5";
import { TurbineInformation } from "./TurbineInformation";
import type {
  PaginatedturbineBladeResultsSideloadList,
  TurbineRetrieve,
} from "../../generated-axios-client/index.ts";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { PageTitleContainer } from "../../../common/components/PageTitle.tsx";
import { actions } from "redux-router5";
import { routeNames } from "../../common/routes.ts";
import type { Dispatch } from "@reduxjs/toolkit";

export type TurbineData = {
  turbine: TurbineRetrieve;
  blades: PaginatedturbineBladeResultsSideloadList;
};

export type TurbineViewRenderProps = {
  intl: IntlShape;
  currentRoute: RouterState | null;
  turbineData: TurbineData;
  modalApi: HookAPI | undefined;
};

type TurbineViewRenderPageProps = TurbineViewRenderProps & {
  dispatch: Dispatch;
};

export const TurbineViewRender = (props: TurbineViewRenderPageProps) => {
  const { intl, currentRoute, turbineData, modalApi, dispatch } = props;
  const { turbine } = turbineData;

  if (!turbine) {
    return null;
  }

  return (
    <PageTitleContainer
      title={`#${turbine.serial_number}`}
      subtitle={turbine.location.name}
      extra={
        <Button
          icon={<EditOutlined />}
          onClick={() =>
            dispatch(actions.navigateTo(routeNames.TURBINE_EDIT, { id: turbine.id }))
          }
        >
          {intl.formatMessage({ id: "turbine_edit_title" })}
        </Button>
      }
    >
      <TurbineInformation
        currentRoute={currentRoute}
        intl={intl}
        turbineData={turbineData}
        modalApi={modalApi}
        dispatch={dispatch}
      />
    </PageTitleContainer>
  );
};
